import {useGetUserProfileQuery} from '../pages/Profile/Profile.api';
import {canManageTariff} from '../utils/userPermissions';
import {useAppSelector} from './app';

/** Профиль + флаг управления тарифом (для владельца / пользователя без компании). */
export function useCanManageTariff() {
    const {token} = useAppSelector(state => state.app);
    const {data: profile, isLoading, isFetching} = useGetUserProfileQuery(
        {token},
        {skip: !token},
    );

    return {
        profile,
        canManageTariff: canManageTariff(profile),
        isLoading: Boolean(token && (isLoading || isFetching)),
    };
}
